import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../core/services/dataBean/useDataBean';
import { _EmployeeContract } from '../../../../../../core/services/dataBean/EntityCatalog';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    _disable?: boolean;
}

export const EmploymentTypeEditor = ({ idSelector, onChange, label, _disable }: Props) => {

    const employeeContract = useDataBean(_EmployeeContract)
    const [lista, setLista] = useState([]);
    const [id, setID] = useState<number>(null);

    useEffect(() => {
        getLista();
    }, [])

    useEffect(() => {
        if (idSelector != id) {
            setID(idSelector);
        }
    }, [idSelector])

    const setValue = (e: any) => {
        const selectedID = parseInt(e);
        onChange(selectedID);
    };

    const getLista = () => {

        employeeContract.instance.getEmploymentTypeCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    return (
        <>
            <label>{label ?? "Tipo de Grupo Laboral"}</label>
            <select disabled={_disable} className="form-select" value={id} onChange={(e) => { setValue(parseInt(e.target.value)) }}>
                <option value={null}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (

                            <option key={index} value={item.DataBeanProperties.IDEmploymentType} >{item.DataBeanProperties.Code} - {item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}